import { TOGGLE_MODAL, UPDATE_MODAL_CONTENT } from './types';

export const toggleModal = (status) => (dispatch) => {
  if (status === undefined) {
    dispatch({
      type:    TOGGLE_MODAL,
      payload: status,
    });
  }
};

export const updateModalContent = (content) => (dispatch) => {
  dispatch({
    type:    UPDATE_MODAL_CONTENT,
    payload: content,
  });
};
